import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const UserDeviceBindingRoutes = defineRoute({
    record: {
        route: {
            path: "/user-device-binding",
            component: () => loadView(import("./UserDeviceBindingHome.vue")),
        },
    },
});
